import M from "@/libs/mapping.js";
import { MOCK_CONFIG } from "@/store/mockData/index.js";
import mockActions from "@/store/modules/supply/mockActions.js";

const actions = {
  // 정산 예정/완료 내역 조회
  async getSettlementSummary({ commit }, params) {
    params.shop_no = sessionStorage.getItem("supply_shop_no");
    try {
      return await M.api(
        M.entry("/get/settlement/summary"),
        params
      );
    } catch (e) {
      console.log(e);
    }
  },
  // 정산 예정/완료 내역 조회
  async getSettlement({ commit }, params) {
    params.shop_no = sessionStorage.getItem("supply_shop_no");
    try {
      return await M.api(
        M.entry("/get/settlement"),
        params
      );
    } catch (e) {
      console.log(e);
    }
  },
  async getSettlementConfirmationUse({ commit }, params) {
    const shop_no = sessionStorage.getItem("supply_shop_no");
    try {
      let result = await M.api(
        M.entry("/get/settlement/completion/use"),
        { shop_no }
      );
      if (!result) {
        result = {
          status: "enabled",
        };
      }
      return result;
    } catch (e) {
      console.log(e);
    }
  },
  async setSettlementConfirmationUse({ commit }, param) {
    const shop_no = sessionStorage.getItem("supply_shop_no");
    try {
      let result = await M.api(
        M.entry("/post/settlement/completion/use", sessionStorage.getItem("supply_shop_no")),
        { status: param }
      );
      if (!result) {
        result = {
          status: "enabled",
        };
      }
      return result;
    } catch (e) {
      console.log(e);
    }
  },
  async setSettlementConfirmation({ commit }, param) {
    try {
      let result = await M.api(
        M.entry("/post/settlement/manual/confirm", sessionStorage.getItem("supply_shop_no")),
        param
      );
      if (!result) {
        result = {
          status: "enabled",
        };
      }
      return result;
    } catch (e) {
      console.log(e);
    }
  },
  // 정산 예정/완료 내역 조회
  async getSettlementDetailList({ commit }, params) {
    params.shop_no = sessionStorage.getItem("supply_shop_no");
    try {
      return await M.api(
        M.entry("/get/settlement/detail"),
        params
      );
    } catch (e) {
      console.log(e);
    }
  },
  // 공급사-설정-조회
  async getSupplierSetting({ commit }, shop_no) {
    if (!shop_no) {
      shop_no = sessionStorage.getItem("supply_shop_no");
    }
    try {
      return await M.api(
        M.entry("/get/suppliers/setting"),
        { shop_no }
      );
    } catch (e) {
      console.log(e);
    }
  },
  async setSettlementManual({ commit }, params) {
    await M.api(M.entry("/post/settlement/manual", sessionStorage.getItem("supply_shop_no")), params);
  },
  async getSettlementDetailView({ commit }, settlement_no) {
    try {
      return await M.api(
        M.entry(
          "/get/settlement/detail/view",
          settlement_no,
          sessionStorage.getItem("supply_shop_no"),
        )
      );
    } catch (e) {
      console.log(e);
    }
  },
  async putSettlementDetailView({ commit }, params) {
    let result = await M.api(
      M.entry(
        "/put/settlement/detail/view",
        params.settlement_no,
        sessionStorage.getItem("supply_shop_no"),
      ),
      params
    );
  },
  async deleteSettlementDetailView({ commit }, settlement_no) {
    let result = await M.api(
      M.entry(
        "/delete/settlement/detail/view",
        settlement_no,
        sessionStorage.getItem("supply_shop_no"),
      )
    );
  },

  async setSettlementPending ({ commit }, settlement_no) {
    return await M.api(
      M.entry(
        "/post/settlement/pending",
        sessionStorage.getItem("supply_shop_no"),
      ),
      settlement_no
    );
  },
  async setSettlementPrepare ({ commit }, settlement_no) {
    return await M.api(
      M.entry(
        "/post/settlement/prepare",
        sessionStorage.getItem("supply_shop_no"),
      ),
      settlement_no
    );
  },

  // 공급사 정산 설정 조회
  async getSupplySettings({ commit }, params) {
    try {
      return await M.api(
        M.entry("/get/supply/settings",
        sessionStorage.getItem("supply_shop_no"),

        ), 
      );
    } catch (e) {
      console.log("공급사 정산 설정 조회 실패:", e);
      throw e;
    }
  },

  // 공급사 정산 설정 저장
  async saveSupplySettings({ commit }, params) {
    try {
      return await M.api(
        M.entry("/post/supply/settings",
        sessionStorage.getItem("supply_shop_no"),
        ),
        { 
          settlement_timing: params.settlement_timing,
          discount_apply_timing: params.discount_apply_timing,  
          discount_items: params.discount_items
        }
      );
    } catch (e) {
      console.log("공급사 정산 설정 저장 실패:", e);
      throw e;
    }
  },

  // 특정 프리셋 상세 조회
  async getExcelPresetDetail({ commit }, presetName) {
    // Mock 데이터 사용 여부 확인
    if (MOCK_CONFIG.USE_EXCEL_TEMPLATE_MOCK || MOCK_CONFIG.USE_ALL_MOCK) {
      return await mockActions.getExcelPresetDetail({ commit }, presetName);
    }
    
    try {
      return await M.api(
        M.entry(`/get/excel/presets/${presetName}`, 
        sessionStorage.getItem("supply_shop_no")
        )
      );
    } catch (e) {
      console.log("엑셀 프리셋 상세 조회 실패:", e);
      // API 실패시 Mock 데이터로 fallback
      console.log("API 실패로 Mock 데이터 사용");
      return await mockActions.getExcelPresetDetail({ commit }, presetName);
    }
  },

  // 커스텀 엑셀 양식 목록 조회
  async getCustomExcelTemplates({ commit }, params) {
    // Mock 데이터 사용 여부 확인
    if (MOCK_CONFIG.USE_EXCEL_TEMPLATE_MOCK || MOCK_CONFIG.USE_ALL_MOCK) {
      return await mockActions.getCustomExcelTemplates({ commit }, params);
    }
    
    try {
      const queryParams = {
        type: params.type || "all", // 'all', 'preset', 'custom'
        order: params.order || "preset_desc",
        offset: params.offset || 0,
        limit: params.limit || 10
      };
      
      return await M.api(
        M.entry("/get/excel/custom", 
        sessionStorage.getItem("supply_shop_no")
        ),
        queryParams
      );
    } catch (e) {
      console.log("커스텀 엑셀 양식 조회 실패:", e);
      // API 실패시 Mock 데이터로 fallback
      console.log("API 실패로 Mock 데이터 사용");
      return await mockActions.getCustomExcelTemplates({ commit }, params);
    }
  },

  // 커스텀 엑셀 양식 상세 조회
  async getCustomExcelTemplateDetail({ commit }, customSettingId) {
    // Mock 데이터 사용 여부 확인
    if (MOCK_CONFIG.USE_EXCEL_TEMPLATE_MOCK || MOCK_CONFIG.USE_ALL_MOCK) {
      return await mockActions.getCustomExcelTemplateDetail({ commit }, customSettingId);
    }
    
    try {
      return await M.api(
        M.entry(`/get/excel/custom/detail`, 
          customSettingId,
          sessionStorage.getItem("supply_shop_no")
          
        )
      );
    } catch (e) {
      console.log("커스텀 엑셀 양식 상세 조회 실패:", e);
      // API 실패시 Mock 데이터로 fallback
      console.log("API 실패로 Mock 데이터 사용");
      return await mockActions.getCustomExcelTemplateDetail({ commit }, customSettingId);
    }
  },

  // 커스텀 엑셀 양식 생성
  async createCustomExcelTemplate({ commit }, params) {
    // Mock 데이터 사용 여부 확인
    if (MOCK_CONFIG.USE_EXCEL_TEMPLATE_MOCK || MOCK_CONFIG.USE_ALL_MOCK) {
      return await mockActions.createCustomExcelTemplate({ commit }, params);
    }
    
    try {
      return await M.api(
        M.entry("/post/excel/custom/detail", 
        sessionStorage.getItem("supply_shop_no")
        ),
        {
          setting_name: params.setting_name,
          column_settings: params.column_settings,
          is_preset: false,
        }
      );
    } catch (e) {
      console.log("커스텀 엑셀 양식 생성 실패:", e);
      throw e;
    }
  },

  // 커스텀 엑셀 양식 수정
  async updateCustomExcelTemplate({ commit }, { customSettingId, params }) {
    // Mock 데이터 사용 여부 확인
    if (MOCK_CONFIG.USE_EXCEL_TEMPLATE_MOCK || MOCK_CONFIG.USE_ALL_MOCK) {
      return await mockActions.updateCustomExcelTemplate({ commit }, { customSettingId, params });
    }
    
    try {
      console.log("커스텀 엑셀 양식 수정:", customSettingId, params);
      return await M.api(
        M.entry(`/put/excel/custom/detail`, 
          customSettingId,
          sessionStorage.getItem("supply_shop_no")
        ),
        {
          setting_name: params.setting_name,
          column_settings: params.column_settings,
          is_preset: false,
        }
      );
    } catch (e) {
      console.log("커스텀 엑셀 양식 수정 실패:", e);
      throw e;
    }
  },

  // 커스텀 엑셀 양식 삭제
  async deleteCustomExcelTemplate({ commit }, customSettingId) {
    // Mock 데이터 사용 여부 확인
    if (MOCK_CONFIG.USE_EXCEL_TEMPLATE_MOCK || MOCK_CONFIG.USE_ALL_MOCK) {
      return await mockActions.deleteCustomExcelTemplate({ commit }, customSettingId);
    }
    
    try {
      return await M.api(
        M.entry(`/delete/excel/custom`, 
          customSettingId,
          sessionStorage.getItem("supply_shop_no")
        )
      );
    } catch (e) {
      console.log("커스텀 엑셀 양식 삭제 실패:", e);
      throw e;
    }
  },

  // 커스텀 엑셀 양식 일괄 삭제
  async bulkDeleteCustomExcelTemplates({ commit }, templateIds) {
    // Mock 데이터 사용 여부 확인
    if (MOCK_CONFIG.USE_EXCEL_TEMPLATE_MOCK || MOCK_CONFIG.USE_ALL_MOCK) {
      return await mockActions.bulkDeleteCustomExcelTemplates({ commit }, templateIds);
    }
    
    try {
      return await M.api(
        M.entry("/delete/excel/custom/bulk", 
        sessionStorage.getItem("supply_shop_no")
        ),
        { custom_setting_ids : templateIds }
      );
    } catch (e) {
      console.log("커스텀 엑셀 양식 일괄 삭제 실패:", e);
      throw e;
    }
  }
};

export default actions;
